import * as React from 'react';

import { Box, Container, Link, Tooltip, Typography } from '@mui/material';

import { AppConfig, Copyright } from '../../../constants/Constants';
import VersionService from '../../../services/version.service';

import './Footer.scss';

export default function Footer() {
  const [apiVersion, setApiVersion] = React.useState<string | null>(null);

  React.useEffect(() => {
    let mounted = true;
    VersionService.getVersion()
      .then((data) => {
        if (!mounted) return;
        if (data && data.version) setApiVersion(data.version);
      })
      .catch(() => null);
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Box component='footer' className='footer'>
      <Container maxWidth='sm'>
        <Typography variant='body2' color='text.secondary' align='center'>
          {'Copyright © '}
          <Link color='inherit' href={Copyright.url} underline='hover'>
            {Copyright.name}
          </Link>{' '}
          {new Date().getFullYear()} {' - version: '}
          <Tooltip title={apiVersion ?? 'Unknown'}>
            <span>{AppConfig.version}</span>
          </Tooltip>
        </Typography>
      </Container>
    </Box>
  );
}
